module.exports = __webpack_public_path__ + "img/SIKH BW.6c17704.svg";